export default "__VITE_ASSET__kykaV6Kt__"